(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/draw-manager.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/draw-manager.js');

'use strict';

const {
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  composeDrawsForDrawSelector
} = svs.components.tipsen.drawManager.utils;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  selectCurrentDrawsByProduct
} = svs.components.tipsen.selectors;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const marketplaceWalletTypes = [WALLET_MARKETPLACE_PLAYER, WALLET_MARKETPLACE_RETAILER];
const {
  DrawManagerContent,
  DrawManagerModal
} = svs.components.tipsen.drawManager;
const {
  loadNetSaleForDraws
} = svs.components.sport.drawsRedux.actions;
const TEN_SECONDS_CACHE = 10000;
const DrawManager = () => {
  const isMediumDevice = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const [isDrawSelectorVisible, setIsDrawSelectorVisible] = useState(false);
  const [showBetEventsByDraw, setShowBetEventsByDraw] = useState([]);
  const {
    drawNumber: currentDrawNumber
  } = useCurrentDraw() || {};
  const [productBranding] = useBranding();
  const draws = useSelector(selectCurrentDrawsByProduct);
  const selectedWallet = useSelector(selectActiveWallet);
  const dispatch = useDispatch();
  const lastNetSaleFetchTimestamp = useRef();
  const lastDrawNumber = useRef(currentDrawNumber);
  const composedDraws = composeDrawsForDrawSelector(draws);
  const composedCurrentDraw = composedDraws.length > 0 ? composedDraws.filter(_ref => {
    let {
      drawNumber
    } = _ref;
    return drawNumber === currentDrawNumber;
  })[0] : null;
  const isExternalInspect = location.pathname.includes("/".concat(TipsenModuleGameUrl.EXTERNAL, "/granska"));
  const shouldEnableDrawSelector = composedDraws.length > 1 && !(isExternalInspect || selectedWallet && marketplaceWalletTypes.includes(selectedWallet.type));
  const shouldShowDrawManagerModal = !isMediumDevice && shouldEnableDrawSelector && isDrawSelectorVisible;
  const toggleBetEvents = useCallback((event, drawNumber) => {
    event.preventDefault();
    event.stopPropagation();
    if (!Array.isArray(showBetEventsByDraw)) {
      setShowBetEventsByDraw([drawNumber]);
    } else if (showBetEventsByDraw.includes(drawNumber)) {
      setShowBetEventsByDraw(showBetEventsByDraw.filter(drawNum => drawNum !== drawNumber));
    } else {
      setShowBetEventsByDraw([...showBetEventsByDraw, drawNumber]);
    }
  }, [showBetEventsByDraw]);
  const toggleDrawSelector = useCallback(async shouldBeVisible => {
    if (typeof shouldBeVisible === 'boolean') {
      setIsDrawSelectorVisible(shouldBeVisible);
    } else {
      setIsDrawSelectorVisible(!isDrawSelectorVisible);
    }
  }, [isDrawSelectorVisible]);
  useEffect(() => {
    if (!isDrawSelectorVisible && currentDrawNumber !== lastDrawNumber.current) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    if (isDrawSelectorVisible) {
      const currentTimestamp = Date.now();
      const shouldFetchNetSales = !lastNetSaleFetchTimestamp.current || currentTimestamp - lastNetSaleFetchTimestamp.current > TEN_SECONDS_CACHE;
      if (shouldFetchNetSales) {
        dispatch(loadNetSaleForDraws({
          productId: composedCurrentDraw.productId
        }));
        lastNetSaleFetchTimestamp.current = Date.now();
      }
    }
    setShowBetEventsByDraw(null);
    lastDrawNumber.current = currentDrawNumber;
  }, [composedCurrentDraw.productId, currentDrawNumber, dispatch, isDrawSelectorVisible]);
  if (!composedCurrentDraw) {
    return null;
  }
  if (shouldShowDrawManagerModal) {
    return React.createElement(DrawManagerModal, {
      composedDraws: composedDraws,
      currentDrawNumber: currentDrawNumber,
      isOpen: isDrawSelectorVisible,
      productBranding: productBranding,
      showBetEventsByDraw: showBetEventsByDraw,
      toggleBetEventsFunc: toggleBetEvents,
      toggleDrawSelector: toggleDrawSelector
    });
  }
  return React.createElement(DrawManagerContent, {
    composedCurrentDraw: composedCurrentDraw,
    composedDraws: composedDraws,
    isDrawSelectorVisible: isDrawSelectorVisible,
    isMediumDevice: isMediumDevice,
    productBranding: productBranding,
    shouldEnableDrawSelector: shouldEnableDrawSelector,
    showBetEventsByDraw: showBetEventsByDraw,
    toggleBetEventsFunc: toggleBetEvents,
    toggleDrawSelector: toggleDrawSelector
  });
};
setGlobal('svs.components.tipsen.drawManager.DrawManager', DrawManager);

 })(window);